import styled from "@emotion/styled";
import colors from "/styles/colors";
import { MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";
export const StyledArticleItemComponent = styled.div`
  &.paragraph {
    padding: 0 32px;
  }

  &.signup {
    margin: 80px 0;
    display: flex;
    justify-content: center;
  }

  &.image,
  &.highlight {
    margin: 64px 0;
    padding: 0 32px;
  }

  .paragraph-title {
    margin-bottom: 8px;

    font-size: 1.75rem;
    font-weight: 400;
    line-height: 42px;
  }

  .paragraph-content {
    margin: 0 0 24px 0;

    font-size: 1rem;
    font-weight: 300;
    line-height: 28px;
  }

  .article-image {
    img {
      width: 100%;
    }
  }

  .highlight-item {
    font-size: 1.463rem;
    font-weight: 300;
    line-height: 38px;

    color: ${colors["brand-purple"]};
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    &.paragraph,
    &.image,
    &.highlight {
      padding: 0;
    }
  }
`;
